module.exports = __webpack_public_path__ + "static/media/Artboard2.bcc96b5a.png";